<template>

	<main class="product-single" ref="cartcontainer">

		<div v-if="!orderComplete" class="page-checkout">
			<div class="container">

				<div class="cart">

					<div class="cart-content row gutter-5" v-show="cartState.items.length">
						<div class="cart-content--form col-md-6 order-1 order-md-0">

							<ValidationObserver ref="observer" v-slot="{ invalid }" tag="form">

								<fieldset>
									<div v-if="surpriseProduct" class="product-surprise">
										<div class="row">
											<div class="col-md">
												<h3 v-text="$__('surprise.product.title')"></h3>
												<p v-text="surprise.lead"></p>
											</div>
											<div class="col-md-auto ml-md-2 pt-2 pt-md-0 d-flex align-items-center justify-content-between d-md-block">
												<div class="h3 price" v-html="formatPrice(surprise.price)"></div>
												<button class="btn btn-white" @click.prevent="addToCart(surprise.id)" v-text="$__('product.general.cart.add')"></button>
											</div>
										</div>
									</div>

									<h4 v-text="$__('checkout.form.billing_title')"></h4>

									<div class="row">
										<div class="col-md-6">
											<div class="form-group input-extra">
												<ValidationProvider rules="required" v-slot="{ errors }">
													<input type="text" class="form-control" name="order_name" id="order-name" v-model="orderModel.name" :class="{ 'is-invalid': errors.length }" :placeholder="$__('checkout.form.billing_name')">
													<label for="order-name" v-text="$__('checkout.form.billing_name')"></label>
													<div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
												</ValidationProvider>
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group input-extra">
												<ValidationProvider rules="required" v-slot="{ errors }">
													<input type="text" class="form-control" name="order_surname" id="order-surname" v-model="orderModel.surname" :class="{ 'is-invalid': errors.length }" :placeholder="$__('checkout.form.billing_surname')">
													<label for="order-surname" v-text="$__('checkout.form.billing_surname')"></label>
													<div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
												</ValidationProvider>
											</div>
										</div>
									</div>


									<div class="form-group input-extra">
										<ValidationProvider rules="required" v-slot="{ errors }">
											<input type="text" class="form-control" name="order_address" id="order-address" v-model="orderModel.address" :class="{ 'is-invalid': errors.length }" :placeholder="$__('checkout.form.billing_address')">
											<label for="order-address" v-text="$__('checkout.form.billing_address')"></label>
											<div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
										</ValidationProvider>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="form-group input-extra">
												<ValidationProvider rules="required" v-slot="{ errors }">
													<input type="text" class="form-control" name="order_post" id="order-post" v-model="orderModel.post" :class="{ 'is-invalid': errors.length }" :placeholder="$__('checkout.form.billing_post')">
													<label for="order-post" v-text="$__('checkout.form.billing_post')"></label>
													<div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
												</ValidationProvider>
											</div>
										</div>
										<div class="col-md-8">
											<div class="form-group input-extra">
												<ValidationProvider rules="required" v-slot="{ errors }">
													<input type="text" class="form-control" name="order_town" id="order-town" v-model="orderModel.town" :class="{ 'is-invalid': errors.length }" :placeholder="$__('checkout.form.billing_town')">
													<label for="order-town" v-text="$__('checkout.form.billing_town')"></label>
													<div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
												</ValidationProvider>
											</div>
										</div>
									</div>
									<div class="form-group">
										<ValidationProvider rules="required|is_not:choose" v-slot="{ errors }">
											<label for="order-country" v-text="$__('checkout.form.billing_country')"></label>
											<select class="custom-select" name="order_country" id="order-country" v-model="orderModel.country" :class="{ 'is-invalid': errors.length }" @change="calculateShipping" autocomplete="new-password">
												<option value="choose" v-text="$__('cart.checkout.select_country')"></option>
												<option v-for="country in countries" v-text="country.title" :value="country.title"></option>
											</select>
											<div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
										</ValidationProvider>
									</div>

									<div class="form-group" v-if="regions && regions.length">
										<ValidationProvider rules="required|is_not:choose_region" v-slot="{ errors }">
											<label for="order-region" v-text="$__('checkout.form.billing_region')"></label>
											<select class="custom-select" name="order_region" id="order-region" v-model="orderModel.region" :class="{ 'is-invalid': errors.length }" @change="calculateShipping" autocomplete="new-password">
												<option value="choose_region" v-text="$__('cart.checkout.select_region')"></option>
												<option v-for="region in regions" v-text="region.title" :value="region.title"></option>
											</select>
											<div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
										</ValidationProvider>
									</div>

									<div class="form-group input-extra">
										<ValidationProvider rules="required|email" v-slot="{ errors }">
											<input type="text" class="form-control" name="order_email" id="order-email" v-bind:readonly="spinWinChecked && isSpinWinCoupon" v-model.trim="orderModel.email" :class="{ 'is-invalid': errors.length }" :placeholder="$__('checkout.form.billing_email')">
											<label for="order-email" v-text="$__('checkout.form.billing_email')"></label>
											<div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
										</ValidationProvider>
									</div>
									<div class="form-group input-extra">
										<ValidationProvider rules="required" v-slot="{ errors }">
											<input type="text" class="form-control" name="order_phone" id="order-phone" v-model="orderModel.phone" :class="{ 'is-invalid': errors.length }" :placeholder="$__('checkout.form.billing_phone')">
											<label for="order-phone" v-text="$__('checkout.form.billing_phone')"></label>
											<div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
										</ValidationProvider>
									</div>

									<div class="form-group">
										<div class="custom-control custom-checkbox">
											<input type="checkbox" class="custom-control-input" id="order-extra-delivery" v-model="orderModel.extra_delivery" @change="differentAddressShipping">
											<label class="custom-control-label" for="order-extra-delivery" v-text="$__('checkout.form.delivery_other')"></label>
										</div>
									</div>

									<div class="extra-delivery" v-if="orderModel.extra_delivery">

										<h4 v-text="$__('checkout.form.delivery_title')"></h4>
										<div class="row">
											<div class="col-md-6">
												<div class="form-group input-extra">
													<ValidationProvider rules="required" v-slot="{ errors }">
														<input type="text" class="form-control" name="order_delivery_name" id="order-delivery-name" v-model="orderModel.delivery_name" :class="{ 'is-invalid': errors.length }" :placeholder="$__('checkout.form.delivery_name')">
														<label for="order-delivery-name" v-text="$__('checkout.form.delivery_name')"></label>
														<div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
													</ValidationProvider>
												</div>
											</div>
											<div class="col-md-6">
												<div class="form-group input-extra">
													<ValidationProvider rules="required" v-slot="{ errors }">
														<input type="text" class="form-control" name="order_delivery_surname" id="order-delivery-surname" v-model="orderModel.delivery_surname" :class="{ 'is-invalid': errors.length }" :placeholder="$__('checkout.form.delivery_surname')">
														<label for="order-delivery-surname" v-text="$__('checkout.form.delivery_surname')"></label>
														<div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
													</ValidationProvider>
												</div>
											</div>
										</div>

										<div class="form-group input-extra">
											<ValidationProvider rules="required" v-slot="{ errors }">
												<input type="text" class="form-control" name="order_delivery_address" id="order-delivery-address" v-model="orderModel.delivery_address" :class="{ 'is-invalid': errors.length }" :placeholder="$__('checkout.form.delivery_address')">
												<label for="order-delivery-address" v-text="$__('checkout.form.delivery_address')"></label>
												<div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
											</ValidationProvider>
										</div>
										<div class="row">
											<div class="col-md-4">
												<div class="form-group input-extra">
													<ValidationProvider rules="required" v-slot="{ errors }">
														<input type="text" class="form-control" name="order_delivery_post" id="order-delivery-post" v-model="orderModel.delivery_post" :class="{ 'is-invalid': errors.length }" :placeholder="$__('checkout.form.delivery_post')">
														<label for="order-delivery-post" v-text="$__('checkout.form.delivery_post')"></label>
														<div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
													</ValidationProvider>
												</div>
											</div>
											<div class="col-md-8">
												<div class="form-group input-extra">
													<ValidationProvider rules="required" v-slot="{ errors }">
														<input type="text" class="form-control" name="order_delivery_town" id="order-delivery-town" v-model="orderModel.delivery_town" :class="{ 'is-invalid': errors.length }" :placeholder="$__('checkout.form.delivery_town')">
														<label for="order-delivery-town" v-text="$__('checkout.form.delivery_town')"></label>
														<div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
													</ValidationProvider>
												</div>
											</div>
										</div>
										<div class="form-group">
											<ValidationProvider rules="required|is_not:choose" v-slot="{ errors }">
												<label for="order-delivery-country" v-text="$__('checkout.form.delivery_country')"></label>
												<select class="custom-select" name="order_delivery_country" id="order-delivery-country" v-model="orderModel.delivery_country" :class="{ 'is-invalid': errors.length }" @change="calculateShipping" autocomplete="new-password">
													<option value="choose" v-text="$__('cart.checkout.select_country')"></option>
													<option v-for="country in countries" v-text="country.title" :value="country.title"></option>
												</select>
												<div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
											</ValidationProvider>
										</div>

										<div class="form-group" v-if="delivery_regions && delivery_regions.length">
											<ValidationProvider rules="required|is_not:choose_region" v-slot="{ errors }">
												<label for="order-delivery-region" v-text="$__('checkout.form.billing_region')"></label>
												<select class="custom-select" name="order_delivery_region" id="order-delivery-region" v-model="orderModel.delivery_region" :class="{ 'is-invalid': errors.length }" @change="calculateShipping" autocomplete="new-password">
													<option value="choose_region" v-text="$__('cart.checkout.select_region')"></option>
													<option v-for="region in delivery_regions" v-text="region.title" :value="region.title"></option>
												</select>
												<div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
											</ValidationProvider>
										</div>

									</div>

									<div class="form-group input-extra">
										<textarea class="form-control" name="order_note" id="order-note" v-model="orderModel.note" :placeholder="$__('checkout.form.note')"></textarea>
										<label for="order-note" v-text="$__('checkout.form.note')"></label>
									</div>

									<div v-html="$__('checkout.form.notice')">
									</div>
									<br>

									<div class="form-group mb-4" v-if="spinWinChecked || !isSpinWinCoupon">
										<ValidationProvider rules="required" v-slot="{ errors }">
											<label for="order-name" v-text="$__('checkout.form.payment_type')"></label>
											<div class="btn-group btn-group-toggle d-flex" data-toggle="buttons" :class="{ 'is-invalid': errors.length }">
												<label class="btn btn-outline-secondary" :class="{ active: getPaymentId == payment.id }" v-for="payment in orderedPayments">
													<input type="radio" v-model="getPaymentId" :value="payment.id" autocomplete="new-password"> <span v-text="payment.title"></span>
												</label>
											</div>
											<div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
										</ValidationProvider>
									</div>

<!--										<div class="form-group mb-4">-->
<!--										<ValidationProvider rules="required" v-slot="{ errors }">-->
<!--											<label for="order-name" v-text="$__('checkout.form.shipping_type')"></label>-->
<!--											<div class="btn-group btn-group-toggle d-flex" data-toggle="buttons" :class="{ 'is-invalid': errors.length }">-->
<!--												<label class="btn btn-outline-secondary" :class="{ active: getShippingId == shipping.id }" v-for="shipping in orderedShippings">-->
<!--													<input type="radio" v-model="getShippingId" :value="shipping.id" autocomplete="off"> <span v-text="shipping.title"></span>-->
<!--												</label>-->
<!--											</div>-->
<!--											<div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>-->
<!--										</ValidationProvider>-->
<!--									</div>-->

									<PaymentStripe
										v-if="['stripe', 'klarna'].includes(getPaymentConst)  && (spinWinChecked || !isSpinWinCoupon)"
										ref="stripePayment"
										:stripe-pk="stripePk"
										:type="getPaymentConst"
										:klarna-valid-countries="klarnaValidCountries"
									/>

									<div class="form-group">
										<ValidationProvider :rules="{ required: { allowFalse: false } }" v-slot="{ errors }">
											<div class="custom-control custom-checkbox" :class="{ 'is-invalid': errors.length }">
												<input type="checkbox" class="custom-control-input" id="agreement-check" v-model="orderModel.agreement">
												<label class="custom-control-label" for="agreement-check">{{ $__('checkout.agreement.prefix') }} <a :href="agreementurl" :title="$__('checkout.agreement.terms')" target="_blank" v-text="$__('checkout.agreement.terms')"></a> {{ $__('checkout.agreement.postfix') }}</label>
											</div>
											<div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
										</ValidationProvider>
									</div>

								</fieldset>

							</ValidationObserver>
								<p v-if="orderError" class="text-danger">{{ orderError }}</p>
								<PaymentPaypal
									v-if="getPaymentConst === 'paypal' && (spinWinChecked || !isSpinWinCoupon)"
									ref="paypalPayment"
									:amount="cartState.total"
									:client-id="paypalClientId"
									:currency="currency"
									:form-valid="checkoutFormValid"
									@validate="validateForm"
									@process="orderProcessPaypal"
								/>
								<button
									v-if="['stripe', 'klarna'].includes(getPaymentConst) && (spinWinChecked || !isSpinWinCoupon)"
									class="btn btn-primary btn-lg btn-block"
									v-text="$__('checkout.form.submit')"
									type="button"
									ref="checkoutSubmitButton"
									@click.prevent="submitForm"
								/>
								<button
									v-if="isSpinWinCoupon && !spinWinChecked"
									class="btn btn-primary btn-lg btn-block"
									type="button"
									@validate="validateForm"
									ref="checkSpinWinButton"
									@click="checkSpinWin"
								>{{ $__('checkout.proceed.button') }}</button>
								<div v-if="recaptcha_error" class="invalid-feedback d-block">
									Recaptcha error. Please contact us.
								</div>
						</div>
						<div class="cart-content--table col-md-6 order-0 order-md-1 mb-md-0 mb-4">
							<cart-table></cart-table>
						</div>
					</div>

					<div class="cart-empty text-center" v-if="!cartState.items.length && cartState.cartLoaded">
						<div class="gr-element gr-element-main">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 112 112">
								<g class="stripe-1">
									<path d="M13.83928,111.20841c-1.141,1.119-2.1553.49756-3.04273-.12457-1.39453-.99444-2.66231-1.98957-4.05691-2.98471-1.52135-1.119-3.0427-2.11414-4.564-3.10858-.50711-.3737-1.01422-.62214-1.141-1.11971a2.68423,2.68423,0,0,1,.12678-1.74114c.25355-.373.88745-.49687,1.52135-.62143a1.93425,1.93425,0,0,1,1.01422.49756c3.0427,2.48715,6.08536,5.09886,9.12809,7.586A9.13151,9.13151,0,0,1,13.83928,111.20841Z" style="fill: #e6007e"/></g>
								<g class="stripe-2">
									<path d="M.908,87.82827c10.64945,5.72029,18.50971,13.68,27.25747,20.76843a10.34175,10.34175,0,0,1,1.52133,2.11414,4.26048,4.26048,0,0,1-4.0569-.12456,53.40111,53.40111,0,0,1-6.97282-4.84973c-5.4515-4.22828-11.1566-8.33271-16.86163-12.31186C.65445,92.55412.78123,91.559.52768,90.56384.14734,89.694.65445,88.82341.908,87.82827Z" style="fill: #e6007e"/></g>
								<g class="stripe-3">
									<path d="M.90716,67.68169c3.29625,2.36286,6.71929,4.22857,9.50841,6.59115C13.71184,77.133,16.501,80.73983,19.79723,83.6c3.80335,3.23315,7.98706,5.96943,12.044,8.95414a14.52417,14.52417,0,0,1,2.15522,1.74114c2.53564,2.73558,4.94441,5.47186,7.48,8.08358,1.39459,1.492,3.04273,2.98471,4.56406,4.47671,1.01424.99515,1.90167,2.11415,2.91592,3.23316-1.77494,1.86571-2.15522,1.74113-3.93016.87056-4.31045-2.11414-7.09964-5.72029-10.64945-8.705-3.423-2.86014-7.09963-5.59643-10.52264-8.58114C20.55786,90.813,17.38839,87.7037,14.09219,84.719c-4.057-3.73072-7.9871-7.46143-12.1708-10.94372A5.20819,5.20819,0,0,1,.0197,69.79583C-.10708,69.04969.4,68.55226.90716,67.68169Z" style="fill: #e6007e"/></g>
								<g class="stripe-4">
									<path d="M66.83114,111.706a32.301,32.301,0,0,1-5.95865-2.73627c-2.66231-1.865-4.94433-4.10372-7.47991-6.21787a46.33325,46.33325,0,0,1-3.93017-2.98471c-3.04265-2.86014-5.95858-5.96943-9.0013-8.95414-4.6908-4.35286-9.38166-8.58114-14.07246-12.93329q-7.60671-7.27563-15.21343-14.5505c-1.90168-1.86543-3.93017-3.6065-5.83186-5.59629-1.52134-1.49236-2.91592-3.109-4.31048-4.60136A2.83992,2.83992,0,0,1,.399,50.02247c.50712-1.24357,1.52135-1.61664,2.53558-.74614,1.01423.74614,1.90168,1.74107,2.91591,2.61157,1.141,1.11928,2.15521,2.61164,3.5498,3.48215,5.705,3.48214,9.762,8.70528,14.70635,12.93357,4.69087,4.10421,8.87451,8.95393,13.43856,13.18222,5.4515,5.22342,10.52264,10.81984,16.608,15.545,4.56406,3.48229,8.36742,7.83514,12.42439,11.93886A5.94146,5.94146,0,0,1,67.59177,110.96C67.21149,111.333,67.08468,111.45685,66.83114,111.706Z" style="fill: #e6007e"/></g>
								<g class="stripe-5">
									<path d="M92.06285,111.08384c-.76069-.12457-1.64806.12457-2.28209-.24843a48.83532,48.83532,0,0,1-5.57823-3.10929c-5.45157-3.48228-9.8884-8.20814-15.467-11.68971-3.9301-2.48715-7.47991-5.84556-11.02972-8.82958a30.29409,30.29409,0,0,1-3.16947-3.85528c-1.90168-2.36329-4.31051-4.47743-5.83185-6.96457a79.76555,79.76555,0,0,0-6.97282-8.82957c-2.53557-2.98472-4.94441-6.09372-7.98707-8.33222A55.51654,55.51654,0,0,1,21.57385,46.54033c-2.282-3.23343-5.4515-6.09372-8.24068-8.95407C10.1637,34.22847,6.7407,31.11947,3.698,27.63732c-.76067-.87049-.88745-2.36285-1.26779-3.85521.50712-.12436,1.01423-.37307,1.39457-.24871A6.87533,6.87533,0,0,1,6.36037,24.777c3.80333,2.98464,7.86031,5.72064,11.28331,8.954,5.705,5.47193,11.0298,11.44129,16.608,17.03757,3.29627,3.35772,6.59254,6.59115,9.6352,10.19758C49.71876,67.93048,55.80415,74.522,61.88953,81.2374c2.40877,2.611,4.6908,5.22272,7.22637,7.586,2.2821,2.11414,4.81753,4.10371,7.09963,6.09329,2.40877,1.99028,4.81753,4.10442,7.2263,6.094a56.547,56.547,0,0,1,8.74769,9.45171A5.31283,5.31283,0,0,1,92.06285,111.08384Z" style="fill: #e6007e"/></g>
								<g class="stripe-6">
									<path d="M111.58561,110.83541c-2.15472,1.492-3.29612,1.492-4.81753.12386-5.07085-4.72516-9.88839-9.70014-14.96-14.4253-3.54946-3.23385-7.353-6.21856-10.90242-9.57627-3.0428-2.86015-5.95893-5.7203-9.00173-8.705a11.587,11.587,0,0,0-1.77474-1.74114c-4.057-2.36328-6.339-6.34244-9.00137-9.82472-.88744-1.11921-1.90168-2.11414-2.78912-3.109C54.66212,59.4739,50.98556,55.37,47.0554,51.3904c-2.40884-2.36286-5.32469-4.35264-7.73352-6.7155-4.43726-4.22829-8.87451-8.58093-13.185-13.18236-2.53558-2.61157-4.8176-5.59621-7.09963-8.45657a8.79239,8.79239,0,0,1-.88744-1.11922c-2.78911-5.47193-7.60672-8.95407-12.044-12.80928C4.96481,8.11261,3.57024,7.242,2.42923,6.12281.65432,4.75484.14721,2.64069,1.415,1.024A1.91367,1.91367,0,0,1,4.07736.27782a10.94182,10.94182,0,0,1,2.91591,1.6167c5.07113,5.22316,10.26908,10.44637,14.95988,15.9183C29.30632,26.51811,37.4202,34.726,45.53407,42.68511c5.95858,5.845,11.91716,11.93872,17.749,17.90808,2.53557,2.61157,4.8176,5.3475,7.22615,7.95907,3.93017,4.104,7.987,8.33229,12.04453,12.31214,3.8028,3.73072,7.86034,7.33687,11.66313,11.06758,2.91614,2.86085,5.45157,5.96943,8.621,8.70571a38.35368,38.35368,0,0,1,6.973,7.33687C110.31826,108.9697,110.95228,109.84027,111.58561,110.83541Z" style="fill: #e6007e"/></g>
								<g class="stripe-7">
									<path d="M111.07825,90.44c-1.5214.49758-2.2821-.24843-3.0428-1.24356-3.29613-4.10372-6.593-8.20815-10.14243-12.06343-3.4228-3.85528-7.2263-7.46143-10.77646-11.06793-3.4228-3.48207-7.353-6.7155-10.01506-10.69508-3.29684-4.60136-7.48019-8.20786-11.28362-12.31178-2.78912-2.98465-5.19788-6.21808-7.86026-9.20272-1.52133-1.74107-3.423-3.35779-4.94441-5.22322-1.77487-1.98978-3.423-4.10392-5.07115-6.21807-4.69079-5.845-9.25485-11.69-13.94564-17.535-.7607-.87053-1.01425-1.741-.12681-2.61159,1.141-1.11925,2.40884-1.24361,3.423-.37308a41.6776,41.6776,0,0,1,4.69086,4.72574C47.30817,12.714,52.75967,18.559,57.32372,25.15011a9.41719,9.41719,0,0,0,1.3946,1.74107c3.93009,4.47707,7.86026,8.82972,11.79021,13.30672a13.71511,13.71511,0,0,0,1.26807,1.36793c6.0856,5.845,12.42453,11.56564,18.38275,17.65936,6.973,7.33736,13.43857,14.92308,17.74943,24.12636a33.18312,33.18312,0,0,0,2.2814,3.48158A3.97372,3.97372,0,0,1,111.07825,90.44Z" style="fill: #e6007e"/></g>
								<g class="stripe-8">
									<path d="M111.58352,63.578c.12667,1.49236-1.014,2.2385-2.15543,1.368a17.27178,17.27178,0,0,1-3.67614-3.73086c-3.04279-3.73085-6.0856-7.58607-9.00172-11.44128-1.77474-2.36286-3.4228-4.97443-5.19753-7.46165-1.01475-1.368-2.02877-2.61164-3.04281-3.97957-.25333-.37307-.7607-.62179-.88736-1.11929-.7607-3.23336-3.16947-5.3475-5.07157-7.83478-2.40877-3.23336-4.81753-6.46679-7.353-9.70015s-5.19823-6.46679-7.73353-9.70021C66.06988,8.11275,64.67536,6.37169,64.295,4.00882c-.12681-.87053-.25354-1.6167.63389-2.11415,1.01425-.6218,1.77488,0,2.40877.62181q4.5642,5.22318,9.12839,10.44634c2.78877,3.35779,5.7049,6.59121,8.367,9.94893,2.6628,3.23343,5.32489,6.59114,7.86033,9.94893,3.67683,4.72572,7.2263,9.4515,10.90313,14.30158,3.54947,4.72571,5.45157,10.44636,7.86034,15.79392A5.29992,5.29992,0,0,0,111.58352,63.578Z" style="fill: #e6007e"/></g>
								<g class="stripe-9">
									<path d="M83.5678.40218a4.54652,4.54652,0,0,0,1.014,1.11925c4.1835,4.97446,8.3677,10.07332,12.5512,15.04775.38.37307.76069.8705,1.14069,1.24364,4.1842,3.73079,7.35367,8.20786,10.39577,12.80922a38.77951,38.77951,0,0,1,2.78946,5.59629,5.17787,5.17787,0,0,1-4.81754-1.98979c-2.2821-2.48728-4.31085-5.22321-6.46559-7.83479-1.39473-1.61671-2.91613-3.10907-4.31087-4.72578-3.04279-3.35772-6.08489-6.7155-8.87436-10.19765A26.518,26.518,0,0,1,84.58183,6.869c-.50737-.99489-1.014-1.86542-1.5214-2.86032C82.55306,2.88941,82.17306,1.6458,83.5678.40218Z" style="fill: #e6007e"/></g>
								<g class="stripe-10">
									<path d="M102.83652,2.39194a7.88784,7.88784,0,0,1,1.5214.9949c2.40876,2.48722,4.81753,4.85012,7.09963,7.33734a1.64506,1.64506,0,0,1-.12667,2.48721,1.63386,1.63386,0,0,1-2.53543-.12435c-2.40877-2.2385-4.9442-4.35265-7.2263-6.83989-.50736-.49745-.254-1.74106-.12736-2.48723C101.69582,3.26247,102.32985,2.88939,102.83652,2.39194Z" style="fill: #e6007e"/></g>
							</svg></div>
						<div class="gr-element gr-element-side">
							<svg viewBox="0 0 220 506" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M42.79 145.521c-1.58-34.64-1.58-69.126-5.211-103.457C36.158 27.68 33.158 13.764 30.474 0H0c3.158 14.073 6.158 28.3 8.21 42.528 8.211 64.023-.157 129.747 9.158 193.306C21.632 265.99 33 294.29 36.79 324.755c4.58 32.785 14.843 58.92 25.737 89.54 9.632 27.682 17.842 56.291 24.158 85.674.316 1.856.79 4.021 1.106 6.031H105c-2.842-29.383-6.947-58.765-12.79-86.756-6-28.61-18.789-54.126-24.315-83.199-2.684-14.228-3.474-28.61-6.632-42.528-4.105-17.475-9.158-34.641-13.105-52.115-6.947-31.393-4.105-64.024-5.369-95.881z" fill="#E6007E"/>
								<path opacity=".5" d="M117.232 141.762c-1.264-27.794-1.264-55.465-4.169-83.011-1.137-11.54-3.537-22.708-5.684-33.751H83c2.526 11.292 4.926 22.707 6.568 34.123 6.569 51.37-.126 104.106 7.327 155.104 3.41 24.196 12.505 46.903 15.537 71.348 3.663 26.305 11.873 47.275 20.589 71.844 7.705 22.211 14.274 45.166 19.326 68.742.253 1.489.632 3.226.885 4.839H167c-2.274-23.576-5.558-47.152-10.232-69.611-4.8-22.955-15.031-43.429-19.452-66.756-2.148-11.416-2.779-22.956-5.305-34.123-3.285-14.022-7.327-27.795-10.485-41.816-5.558-25.189-3.284-51.371-4.294-76.932z" fill="#E6007E"/>
								<path opacity=".2" d="M188.598 172.061c-.797-17.868-.797-35.656-2.63-53.364-.717-7.419-2.231-14.598-3.586-21.697H167c1.594 7.259 3.108 14.597 4.144 21.936 4.145 33.024-.079 66.925 4.623 99.71 2.152 15.554 7.89 30.152 9.803 45.866 2.311 16.911 7.492 30.392 12.991 46.186 4.862 14.278 9.006 29.035 12.194 44.191.159.957.398 2.074.558 3.111H220c-1.435-15.156-3.507-30.312-6.456-44.75-3.028-14.757-9.484-27.918-12.273-42.915-1.355-7.338-1.754-14.757-3.348-21.936-2.072-9.014-4.622-17.868-6.615-26.882-3.506-16.192-2.072-33.023-2.71-49.456z" fill="#E6007E"/>
							</svg>
						</div>
						<h1>{{ $__('cart.empty.title') }}</h1>
						<div class="links">
							<a class="btn btn-primary" href="/" v-text="$__('cart.empty.back')"></a>
						</div>
					</div>

				</div>

			</div>
		</div>
		<div v-else-if="orderComplete && orderSuccess">
			<div class="col text-center">
				<div class="gr-element gr-element-main">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 112 112">
						<g class="stripe-1">
						<path d="M13.83928,111.20841c-1.141,1.119-2.1553.49756-3.04273-.12457-1.39453-.99444-2.66231-1.98957-4.05691-2.98471-1.52135-1.119-3.0427-2.11414-4.564-3.10858-.50711-.3737-1.01422-.62214-1.141-1.11971a2.68423,2.68423,0,0,1,.12678-1.74114c.25355-.373.88745-.49687,1.52135-.62143a1.93425,1.93425,0,0,1,1.01422.49756c3.0427,2.48715,6.08536,5.09886,9.12809,7.586A9.13151,9.13151,0,0,1,13.83928,111.20841Z" style="fill: #e6007e"/></g>
						<g class="stripe-2">
						<path d="M.908,87.82827c10.64945,5.72029,18.50971,13.68,27.25747,20.76843a10.34175,10.34175,0,0,1,1.52133,2.11414,4.26048,4.26048,0,0,1-4.0569-.12456,53.40111,53.40111,0,0,1-6.97282-4.84973c-5.4515-4.22828-11.1566-8.33271-16.86163-12.31186C.65445,92.55412.78123,91.559.52768,90.56384.14734,89.694.65445,88.82341.908,87.82827Z" style="fill: #e6007e"/></g>
						<g class="stripe-3">
						<path d="M.90716,67.68169c3.29625,2.36286,6.71929,4.22857,9.50841,6.59115C13.71184,77.133,16.501,80.73983,19.79723,83.6c3.80335,3.23315,7.98706,5.96943,12.044,8.95414a14.52417,14.52417,0,0,1,2.15522,1.74114c2.53564,2.73558,4.94441,5.47186,7.48,8.08358,1.39459,1.492,3.04273,2.98471,4.56406,4.47671,1.01424.99515,1.90167,2.11415,2.91592,3.23316-1.77494,1.86571-2.15522,1.74113-3.93016.87056-4.31045-2.11414-7.09964-5.72029-10.64945-8.705-3.423-2.86014-7.09963-5.59643-10.52264-8.58114C20.55786,90.813,17.38839,87.7037,14.09219,84.719c-4.057-3.73072-7.9871-7.46143-12.1708-10.94372A5.20819,5.20819,0,0,1,.0197,69.79583C-.10708,69.04969.4,68.55226.90716,67.68169Z" style="fill: #e6007e"/></g>
						<g class="stripe-4">
						<path d="M66.83114,111.706a32.301,32.301,0,0,1-5.95865-2.73627c-2.66231-1.865-4.94433-4.10372-7.47991-6.21787a46.33325,46.33325,0,0,1-3.93017-2.98471c-3.04265-2.86014-5.95858-5.96943-9.0013-8.95414-4.6908-4.35286-9.38166-8.58114-14.07246-12.93329q-7.60671-7.27563-15.21343-14.5505c-1.90168-1.86543-3.93017-3.6065-5.83186-5.59629-1.52134-1.49236-2.91592-3.109-4.31048-4.60136A2.83992,2.83992,0,0,1,.399,50.02247c.50712-1.24357,1.52135-1.61664,2.53558-.74614,1.01423.74614,1.90168,1.74107,2.91591,2.61157,1.141,1.11928,2.15521,2.61164,3.5498,3.48215,5.705,3.48214,9.762,8.70528,14.70635,12.93357,4.69087,4.10421,8.87451,8.95393,13.43856,13.18222,5.4515,5.22342,10.52264,10.81984,16.608,15.545,4.56406,3.48229,8.36742,7.83514,12.42439,11.93886A5.94146,5.94146,0,0,1,67.59177,110.96C67.21149,111.333,67.08468,111.45685,66.83114,111.706Z" style="fill: #e6007e"/></g>
						<g class="stripe-5">
						<path d="M92.06285,111.08384c-.76069-.12457-1.64806.12457-2.28209-.24843a48.83532,48.83532,0,0,1-5.57823-3.10929c-5.45157-3.48228-9.8884-8.20814-15.467-11.68971-3.9301-2.48715-7.47991-5.84556-11.02972-8.82958a30.29409,30.29409,0,0,1-3.16947-3.85528c-1.90168-2.36329-4.31051-4.47743-5.83185-6.96457a79.76555,79.76555,0,0,0-6.97282-8.82957c-2.53557-2.98472-4.94441-6.09372-7.98707-8.33222A55.51654,55.51654,0,0,1,21.57385,46.54033c-2.282-3.23343-5.4515-6.09372-8.24068-8.95407C10.1637,34.22847,6.7407,31.11947,3.698,27.63732c-.76067-.87049-.88745-2.36285-1.26779-3.85521.50712-.12436,1.01423-.37307,1.39457-.24871A6.87533,6.87533,0,0,1,6.36037,24.777c3.80333,2.98464,7.86031,5.72064,11.28331,8.954,5.705,5.47193,11.0298,11.44129,16.608,17.03757,3.29627,3.35772,6.59254,6.59115,9.6352,10.19758C49.71876,67.93048,55.80415,74.522,61.88953,81.2374c2.40877,2.611,4.6908,5.22272,7.22637,7.586,2.2821,2.11414,4.81753,4.10371,7.09963,6.09329,2.40877,1.99028,4.81753,4.10442,7.2263,6.094a56.547,56.547,0,0,1,8.74769,9.45171A5.31283,5.31283,0,0,1,92.06285,111.08384Z" style="fill: #e6007e"/></g>
						<g class="stripe-6">
						<path d="M111.58561,110.83541c-2.15472,1.492-3.29612,1.492-4.81753.12386-5.07085-4.72516-9.88839-9.70014-14.96-14.4253-3.54946-3.23385-7.353-6.21856-10.90242-9.57627-3.0428-2.86015-5.95893-5.7203-9.00173-8.705a11.587,11.587,0,0,0-1.77474-1.74114c-4.057-2.36328-6.339-6.34244-9.00137-9.82472-.88744-1.11921-1.90168-2.11414-2.78912-3.109C54.66212,59.4739,50.98556,55.37,47.0554,51.3904c-2.40884-2.36286-5.32469-4.35264-7.73352-6.7155-4.43726-4.22829-8.87451-8.58093-13.185-13.18236-2.53558-2.61157-4.8176-5.59621-7.09963-8.45657a8.79239,8.79239,0,0,1-.88744-1.11922c-2.78911-5.47193-7.60672-8.95407-12.044-12.80928C4.96481,8.11261,3.57024,7.242,2.42923,6.12281.65432,4.75484.14721,2.64069,1.415,1.024A1.91367,1.91367,0,0,1,4.07736.27782a10.94182,10.94182,0,0,1,2.91591,1.6167c5.07113,5.22316,10.26908,10.44637,14.95988,15.9183C29.30632,26.51811,37.4202,34.726,45.53407,42.68511c5.95858,5.845,11.91716,11.93872,17.749,17.90808,2.53557,2.61157,4.8176,5.3475,7.22615,7.95907,3.93017,4.104,7.987,8.33229,12.04453,12.31214,3.8028,3.73072,7.86034,7.33687,11.66313,11.06758,2.91614,2.86085,5.45157,5.96943,8.621,8.70571a38.35368,38.35368,0,0,1,6.973,7.33687C110.31826,108.9697,110.95228,109.84027,111.58561,110.83541Z" style="fill: #e6007e"/></g>
						<g class="stripe-7">
						<path d="M111.07825,90.44c-1.5214.49758-2.2821-.24843-3.0428-1.24356-3.29613-4.10372-6.593-8.20815-10.14243-12.06343-3.4228-3.85528-7.2263-7.46143-10.77646-11.06793-3.4228-3.48207-7.353-6.7155-10.01506-10.69508-3.29684-4.60136-7.48019-8.20786-11.28362-12.31178-2.78912-2.98465-5.19788-6.21808-7.86026-9.20272-1.52133-1.74107-3.423-3.35779-4.94441-5.22322-1.77487-1.98978-3.423-4.10392-5.07115-6.21807-4.69079-5.845-9.25485-11.69-13.94564-17.535-.7607-.87053-1.01425-1.741-.12681-2.61159,1.141-1.11925,2.40884-1.24361,3.423-.37308a41.6776,41.6776,0,0,1,4.69086,4.72574C47.30817,12.714,52.75967,18.559,57.32372,25.15011a9.41719,9.41719,0,0,0,1.3946,1.74107c3.93009,4.47707,7.86026,8.82972,11.79021,13.30672a13.71511,13.71511,0,0,0,1.26807,1.36793c6.0856,5.845,12.42453,11.56564,18.38275,17.65936,6.973,7.33736,13.43857,14.92308,17.74943,24.12636a33.18312,33.18312,0,0,0,2.2814,3.48158A3.97372,3.97372,0,0,1,111.07825,90.44Z" style="fill: #e6007e"/></g>
						<g class="stripe-8">
						<path d="M111.58352,63.578c.12667,1.49236-1.014,2.2385-2.15543,1.368a17.27178,17.27178,0,0,1-3.67614-3.73086c-3.04279-3.73085-6.0856-7.58607-9.00172-11.44128-1.77474-2.36286-3.4228-4.97443-5.19753-7.46165-1.01475-1.368-2.02877-2.61164-3.04281-3.97957-.25333-.37307-.7607-.62179-.88736-1.11929-.7607-3.23336-3.16947-5.3475-5.07157-7.83478-2.40877-3.23336-4.81753-6.46679-7.353-9.70015s-5.19823-6.46679-7.73353-9.70021C66.06988,8.11275,64.67536,6.37169,64.295,4.00882c-.12681-.87053-.25354-1.6167.63389-2.11415,1.01425-.6218,1.77488,0,2.40877.62181q4.5642,5.22318,9.12839,10.44634c2.78877,3.35779,5.7049,6.59121,8.367,9.94893,2.6628,3.23343,5.32489,6.59114,7.86033,9.94893,3.67683,4.72572,7.2263,9.4515,10.90313,14.30158,3.54947,4.72571,5.45157,10.44636,7.86034,15.79392A5.29992,5.29992,0,0,0,111.58352,63.578Z" style="fill: #e6007e"/></g>
						<g class="stripe-9">
						<path d="M83.5678.40218a4.54652,4.54652,0,0,0,1.014,1.11925c4.1835,4.97446,8.3677,10.07332,12.5512,15.04775.38.37307.76069.8705,1.14069,1.24364,4.1842,3.73079,7.35367,8.20786,10.39577,12.80922a38.77951,38.77951,0,0,1,2.78946,5.59629,5.17787,5.17787,0,0,1-4.81754-1.98979c-2.2821-2.48728-4.31085-5.22321-6.46559-7.83479-1.39473-1.61671-2.91613-3.10907-4.31087-4.72578-3.04279-3.35772-6.08489-6.7155-8.87436-10.19765A26.518,26.518,0,0,1,84.58183,6.869c-.50737-.99489-1.014-1.86542-1.5214-2.86032C82.55306,2.88941,82.17306,1.6458,83.5678.40218Z" style="fill: #e6007e"/></g>
						<g class="stripe-10">
						<path d="M102.83652,2.39194a7.88784,7.88784,0,0,1,1.5214.9949c2.40876,2.48722,4.81753,4.85012,7.09963,7.33734a1.64506,1.64506,0,0,1-.12667,2.48721,1.63386,1.63386,0,0,1-2.53543-.12435c-2.40877-2.2385-4.9442-4.35265-7.2263-6.83989-.50736-.49745-.254-1.74106-.12736-2.48723C101.69582,3.26247,102.32985,2.88939,102.83652,2.39194Z" style="fill: #e6007e"/></g>
					</svg>
				</div>
				<div class="gr-element gr-element-side">
					<svg viewBox="0 0 220 506" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M42.79 145.521c-1.58-34.64-1.58-69.126-5.211-103.457C36.158 27.68 33.158 13.764 30.474 0H0c3.158 14.073 6.158 28.3 8.21 42.528 8.211 64.023-.157 129.747 9.158 193.306C21.632 265.99 33 294.29 36.79 324.755c4.58 32.785 14.843 58.92 25.737 89.54 9.632 27.682 17.842 56.291 24.158 85.674.316 1.856.79 4.021 1.106 6.031H105c-2.842-29.383-6.947-58.765-12.79-86.756-6-28.61-18.789-54.126-24.315-83.199-2.684-14.228-3.474-28.61-6.632-42.528-4.105-17.475-9.158-34.641-13.105-52.115-6.947-31.393-4.105-64.024-5.369-95.881z" fill="#E6007E"/>
						<path opacity=".5" d="M117.232 141.762c-1.264-27.794-1.264-55.465-4.169-83.011-1.137-11.54-3.537-22.708-5.684-33.751H83c2.526 11.292 4.926 22.707 6.568 34.123 6.569 51.37-.126 104.106 7.327 155.104 3.41 24.196 12.505 46.903 15.537 71.348 3.663 26.305 11.873 47.275 20.589 71.844 7.705 22.211 14.274 45.166 19.326 68.742.253 1.489.632 3.226.885 4.839H167c-2.274-23.576-5.558-47.152-10.232-69.611-4.8-22.955-15.031-43.429-19.452-66.756-2.148-11.416-2.779-22.956-5.305-34.123-3.285-14.022-7.327-27.795-10.485-41.816-5.558-25.189-3.284-51.371-4.294-76.932z" fill="#E6007E"/>
						<path opacity=".2" d="M188.598 172.061c-.797-17.868-.797-35.656-2.63-53.364-.717-7.419-2.231-14.598-3.586-21.697H167c1.594 7.259 3.108 14.597 4.144 21.936 4.145 33.024-.079 66.925 4.623 99.71 2.152 15.554 7.89 30.152 9.803 45.866 2.311 16.911 7.492 30.392 12.991 46.186 4.862 14.278 9.006 29.035 12.194 44.191.159.957.398 2.074.558 3.111H220c-1.435-15.156-3.507-30.312-6.456-44.75-3.028-14.757-9.484-27.918-12.273-42.915-1.355-7.338-1.754-14.757-3.348-21.936-2.072-9.014-4.622-17.868-6.615-26.882-3.506-16.192-2.072-33.023-2.71-49.456z" fill="#E6007E"/>
					</svg>
				</div>
				<h2 v-text="$__('checkout.done.title')"></h2>
				<div class="icon">
					<svg viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M35.233 7.683a9.167 9.167 0 00-12.966 0L20.5 9.45l-1.767-1.767A9.169 9.169 0 105.767 20.65l1.766 1.767L20.5 35.383l12.967-12.966 1.766-1.767a9.166 9.166 0 000-12.967v0z" stroke="#E6007E" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></div>
				<p v-text="$__('checkout.done.content')"></p>
				<p v-if="orderWarning" class="text-danger">{{ orderWarning }}</p>
				<a href="/" class="btn btn-primary" v-text="$__('checkout.done.back')"></a>
			</div>
		</div>
		<div v-else-if="orderComplete && !orderSuccess">
			<div class="col text-center">
				<div class="gr-element gr-element-main">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 112 112">
					<g class="stripe-1">
						<path d="M13.83928,111.20841c-1.141,1.119-2.1553.49756-3.04273-.12457-1.39453-.99444-2.66231-1.98957-4.05691-2.98471-1.52135-1.119-3.0427-2.11414-4.564-3.10858-.50711-.3737-1.01422-.62214-1.141-1.11971a2.68423,2.68423,0,0,1,.12678-1.74114c.25355-.373.88745-.49687,1.52135-.62143a1.93425,1.93425,0,0,1,1.01422.49756c3.0427,2.48715,6.08536,5.09886,9.12809,7.586A9.13151,9.13151,0,0,1,13.83928,111.20841Z" style="fill: #e6007e"/></g>
					<g class="stripe-2">
						<path d="M.908,87.82827c10.64945,5.72029,18.50971,13.68,27.25747,20.76843a10.34175,10.34175,0,0,1,1.52133,2.11414,4.26048,4.26048,0,0,1-4.0569-.12456,53.40111,53.40111,0,0,1-6.97282-4.84973c-5.4515-4.22828-11.1566-8.33271-16.86163-12.31186C.65445,92.55412.78123,91.559.52768,90.56384.14734,89.694.65445,88.82341.908,87.82827Z" style="fill: #e6007e"/></g>
					<g class="stripe-3">
						<path d="M.90716,67.68169c3.29625,2.36286,6.71929,4.22857,9.50841,6.59115C13.71184,77.133,16.501,80.73983,19.79723,83.6c3.80335,3.23315,7.98706,5.96943,12.044,8.95414a14.52417,14.52417,0,0,1,2.15522,1.74114c2.53564,2.73558,4.94441,5.47186,7.48,8.08358,1.39459,1.492,3.04273,2.98471,4.56406,4.47671,1.01424.99515,1.90167,2.11415,2.91592,3.23316-1.77494,1.86571-2.15522,1.74113-3.93016.87056-4.31045-2.11414-7.09964-5.72029-10.64945-8.705-3.423-2.86014-7.09963-5.59643-10.52264-8.58114C20.55786,90.813,17.38839,87.7037,14.09219,84.719c-4.057-3.73072-7.9871-7.46143-12.1708-10.94372A5.20819,5.20819,0,0,1,.0197,69.79583C-.10708,69.04969.4,68.55226.90716,67.68169Z" style="fill: #e6007e"/></g>
					<g class="stripe-4">
						<path d="M66.83114,111.706a32.301,32.301,0,0,1-5.95865-2.73627c-2.66231-1.865-4.94433-4.10372-7.47991-6.21787a46.33325,46.33325,0,0,1-3.93017-2.98471c-3.04265-2.86014-5.95858-5.96943-9.0013-8.95414-4.6908-4.35286-9.38166-8.58114-14.07246-12.93329q-7.60671-7.27563-15.21343-14.5505c-1.90168-1.86543-3.93017-3.6065-5.83186-5.59629-1.52134-1.49236-2.91592-3.109-4.31048-4.60136A2.83992,2.83992,0,0,1,.399,50.02247c.50712-1.24357,1.52135-1.61664,2.53558-.74614,1.01423.74614,1.90168,1.74107,2.91591,2.61157,1.141,1.11928,2.15521,2.61164,3.5498,3.48215,5.705,3.48214,9.762,8.70528,14.70635,12.93357,4.69087,4.10421,8.87451,8.95393,13.43856,13.18222,5.4515,5.22342,10.52264,10.81984,16.608,15.545,4.56406,3.48229,8.36742,7.83514,12.42439,11.93886A5.94146,5.94146,0,0,1,67.59177,110.96C67.21149,111.333,67.08468,111.45685,66.83114,111.706Z" style="fill: #e6007e"/></g>
					<g class="stripe-5">
						<path d="M92.06285,111.08384c-.76069-.12457-1.64806.12457-2.28209-.24843a48.83532,48.83532,0,0,1-5.57823-3.10929c-5.45157-3.48228-9.8884-8.20814-15.467-11.68971-3.9301-2.48715-7.47991-5.84556-11.02972-8.82958a30.29409,30.29409,0,0,1-3.16947-3.85528c-1.90168-2.36329-4.31051-4.47743-5.83185-6.96457a79.76555,79.76555,0,0,0-6.97282-8.82957c-2.53557-2.98472-4.94441-6.09372-7.98707-8.33222A55.51654,55.51654,0,0,1,21.57385,46.54033c-2.282-3.23343-5.4515-6.09372-8.24068-8.95407C10.1637,34.22847,6.7407,31.11947,3.698,27.63732c-.76067-.87049-.88745-2.36285-1.26779-3.85521.50712-.12436,1.01423-.37307,1.39457-.24871A6.87533,6.87533,0,0,1,6.36037,24.777c3.80333,2.98464,7.86031,5.72064,11.28331,8.954,5.705,5.47193,11.0298,11.44129,16.608,17.03757,3.29627,3.35772,6.59254,6.59115,9.6352,10.19758C49.71876,67.93048,55.80415,74.522,61.88953,81.2374c2.40877,2.611,4.6908,5.22272,7.22637,7.586,2.2821,2.11414,4.81753,4.10371,7.09963,6.09329,2.40877,1.99028,4.81753,4.10442,7.2263,6.094a56.547,56.547,0,0,1,8.74769,9.45171A5.31283,5.31283,0,0,1,92.06285,111.08384Z" style="fill: #e6007e"/></g>
					<g class="stripe-6">
						<path d="M111.58561,110.83541c-2.15472,1.492-3.29612,1.492-4.81753.12386-5.07085-4.72516-9.88839-9.70014-14.96-14.4253-3.54946-3.23385-7.353-6.21856-10.90242-9.57627-3.0428-2.86015-5.95893-5.7203-9.00173-8.705a11.587,11.587,0,0,0-1.77474-1.74114c-4.057-2.36328-6.339-6.34244-9.00137-9.82472-.88744-1.11921-1.90168-2.11414-2.78912-3.109C54.66212,59.4739,50.98556,55.37,47.0554,51.3904c-2.40884-2.36286-5.32469-4.35264-7.73352-6.7155-4.43726-4.22829-8.87451-8.58093-13.185-13.18236-2.53558-2.61157-4.8176-5.59621-7.09963-8.45657a8.79239,8.79239,0,0,1-.88744-1.11922c-2.78911-5.47193-7.60672-8.95407-12.044-12.80928C4.96481,8.11261,3.57024,7.242,2.42923,6.12281.65432,4.75484.14721,2.64069,1.415,1.024A1.91367,1.91367,0,0,1,4.07736.27782a10.94182,10.94182,0,0,1,2.91591,1.6167c5.07113,5.22316,10.26908,10.44637,14.95988,15.9183C29.30632,26.51811,37.4202,34.726,45.53407,42.68511c5.95858,5.845,11.91716,11.93872,17.749,17.90808,2.53557,2.61157,4.8176,5.3475,7.22615,7.95907,3.93017,4.104,7.987,8.33229,12.04453,12.31214,3.8028,3.73072,7.86034,7.33687,11.66313,11.06758,2.91614,2.86085,5.45157,5.96943,8.621,8.70571a38.35368,38.35368,0,0,1,6.973,7.33687C110.31826,108.9697,110.95228,109.84027,111.58561,110.83541Z" style="fill: #e6007e"/></g>
					<g class="stripe-7">
						<path d="M111.07825,90.44c-1.5214.49758-2.2821-.24843-3.0428-1.24356-3.29613-4.10372-6.593-8.20815-10.14243-12.06343-3.4228-3.85528-7.2263-7.46143-10.77646-11.06793-3.4228-3.48207-7.353-6.7155-10.01506-10.69508-3.29684-4.60136-7.48019-8.20786-11.28362-12.31178-2.78912-2.98465-5.19788-6.21808-7.86026-9.20272-1.52133-1.74107-3.423-3.35779-4.94441-5.22322-1.77487-1.98978-3.423-4.10392-5.07115-6.21807-4.69079-5.845-9.25485-11.69-13.94564-17.535-.7607-.87053-1.01425-1.741-.12681-2.61159,1.141-1.11925,2.40884-1.24361,3.423-.37308a41.6776,41.6776,0,0,1,4.69086,4.72574C47.30817,12.714,52.75967,18.559,57.32372,25.15011a9.41719,9.41719,0,0,0,1.3946,1.74107c3.93009,4.47707,7.86026,8.82972,11.79021,13.30672a13.71511,13.71511,0,0,0,1.26807,1.36793c6.0856,5.845,12.42453,11.56564,18.38275,17.65936,6.973,7.33736,13.43857,14.92308,17.74943,24.12636a33.18312,33.18312,0,0,0,2.2814,3.48158A3.97372,3.97372,0,0,1,111.07825,90.44Z" style="fill: #e6007e"/></g>
					<g class="stripe-8">
						<path d="M111.58352,63.578c.12667,1.49236-1.014,2.2385-2.15543,1.368a17.27178,17.27178,0,0,1-3.67614-3.73086c-3.04279-3.73085-6.0856-7.58607-9.00172-11.44128-1.77474-2.36286-3.4228-4.97443-5.19753-7.46165-1.01475-1.368-2.02877-2.61164-3.04281-3.97957-.25333-.37307-.7607-.62179-.88736-1.11929-.7607-3.23336-3.16947-5.3475-5.07157-7.83478-2.40877-3.23336-4.81753-6.46679-7.353-9.70015s-5.19823-6.46679-7.73353-9.70021C66.06988,8.11275,64.67536,6.37169,64.295,4.00882c-.12681-.87053-.25354-1.6167.63389-2.11415,1.01425-.6218,1.77488,0,2.40877.62181q4.5642,5.22318,9.12839,10.44634c2.78877,3.35779,5.7049,6.59121,8.367,9.94893,2.6628,3.23343,5.32489,6.59114,7.86033,9.94893,3.67683,4.72572,7.2263,9.4515,10.90313,14.30158,3.54947,4.72571,5.45157,10.44636,7.86034,15.79392A5.29992,5.29992,0,0,0,111.58352,63.578Z" style="fill: #e6007e"/></g>
					<g class="stripe-9">
						<path d="M83.5678.40218a4.54652,4.54652,0,0,0,1.014,1.11925c4.1835,4.97446,8.3677,10.07332,12.5512,15.04775.38.37307.76069.8705,1.14069,1.24364,4.1842,3.73079,7.35367,8.20786,10.39577,12.80922a38.77951,38.77951,0,0,1,2.78946,5.59629,5.17787,5.17787,0,0,1-4.81754-1.98979c-2.2821-2.48728-4.31085-5.22321-6.46559-7.83479-1.39473-1.61671-2.91613-3.10907-4.31087-4.72578-3.04279-3.35772-6.08489-6.7155-8.87436-10.19765A26.518,26.518,0,0,1,84.58183,6.869c-.50737-.99489-1.014-1.86542-1.5214-2.86032C82.55306,2.88941,82.17306,1.6458,83.5678.40218Z" style="fill: #e6007e"/></g>
					<g class="stripe-10">
						<path d="M102.83652,2.39194a7.88784,7.88784,0,0,1,1.5214.9949c2.40876,2.48722,4.81753,4.85012,7.09963,7.33734a1.64506,1.64506,0,0,1-.12667,2.48721,1.63386,1.63386,0,0,1-2.53543-.12435c-2.40877-2.2385-4.9442-4.35265-7.2263-6.83989-.50736-.49745-.254-1.74106-.12736-2.48723C101.69582,3.26247,102.32985,2.88939,102.83652,2.39194Z" style="fill: #e6007e"/></g>
					</svg>
				</div>
				<div class="gr-element gr-element-side">
					<svg viewBox="0 0 220 506" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M42.79 145.521c-1.58-34.64-1.58-69.126-5.211-103.457C36.158 27.68 33.158 13.764 30.474 0H0c3.158 14.073 6.158 28.3 8.21 42.528 8.211 64.023-.157 129.747 9.158 193.306C21.632 265.99 33 294.29 36.79 324.755c4.58 32.785 14.843 58.92 25.737 89.54 9.632 27.682 17.842 56.291 24.158 85.674.316 1.856.79 4.021 1.106 6.031H105c-2.842-29.383-6.947-58.765-12.79-86.756-6-28.61-18.789-54.126-24.315-83.199-2.684-14.228-3.474-28.61-6.632-42.528-4.105-17.475-9.158-34.641-13.105-52.115-6.947-31.393-4.105-64.024-5.369-95.881z" fill="#E6007E"/>
						<path opacity=".5" d="M117.232 141.762c-1.264-27.794-1.264-55.465-4.169-83.011-1.137-11.54-3.537-22.708-5.684-33.751H83c2.526 11.292 4.926 22.707 6.568 34.123 6.569 51.37-.126 104.106 7.327 155.104 3.41 24.196 12.505 46.903 15.537 71.348 3.663 26.305 11.873 47.275 20.589 71.844 7.705 22.211 14.274 45.166 19.326 68.742.253 1.489.632 3.226.885 4.839H167c-2.274-23.576-5.558-47.152-10.232-69.611-4.8-22.955-15.031-43.429-19.452-66.756-2.148-11.416-2.779-22.956-5.305-34.123-3.285-14.022-7.327-27.795-10.485-41.816-5.558-25.189-3.284-51.371-4.294-76.932z" fill="#E6007E"/>
						<path opacity=".2" d="M188.598 172.061c-.797-17.868-.797-35.656-2.63-53.364-.717-7.419-2.231-14.598-3.586-21.697H167c1.594 7.259 3.108 14.597 4.144 21.936 4.145 33.024-.079 66.925 4.623 99.71 2.152 15.554 7.89 30.152 9.803 45.866 2.311 16.911 7.492 30.392 12.991 46.186 4.862 14.278 9.006 29.035 12.194 44.191.159.957.398 2.074.558 3.111H220c-1.435-15.156-3.507-30.312-6.456-44.75-3.028-14.757-9.484-27.918-12.273-42.915-1.355-7.338-1.754-14.757-3.348-21.936-2.072-9.014-4.622-17.868-6.615-26.882-3.506-16.192-2.072-33.023-2.71-49.456z" fill="#E6007E"/>
					</svg>
				</div>
				<h2 v-text="$__('checkout.done.titleerror')" />
				<div class="icon">
					<svg viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M23 23.5L18.5 20l4.5-4-4.5-4.5 3.767-3.817a9.167 9.167 0 0115.653 6.484 9.167 9.167 0 01-2.687 6.483l-1.766 1.767L20.5 35.383 7.533 22.417 5.767 20.65A9.169 9.169 0 0112.25 4.998c.917-.096 3.25.306 5.25 2.685" stroke="#E6007E" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>
				</div>
				<p v-text="$__('checkout.done.contenterror')" />
				<p v-if="orderError">{{ $__('checkout.done.error') }} {{ orderError }}</p>
				<a href="/" class="btn btn-primary" v-text="$__('checkout.done.back')" />
			</div>
		</div>

		<Upsell
			v-if="upsellProduct"
			:upsell="upsellProduct"
		></Upsell>
	</main>

</template>
<script>
import CartTable from "./CartTable";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Paypal from "../Payment/Paypal.vue";
import Stripe from "../Payment/Stripe.vue";
Vue.component('PaymentPaypal', Paypal);
Vue.component('PaymentStripe', Stripe);

// vee-validate
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email, numeric, is_not } from 'vee-validate/dist/rules';
import {mapGetters} from "vuex";
import Upsell from "../Upsell.vue";
Vue.component('ValidationProvider', ValidationProvider);

export default {
	name: 'CartCheckout',
	components: {
		Upsell,
		CartTable,
		ValidationObserver,
		Loading
	},
	props: {
		payurl: {
			type: String,
			required: true
		},
		checkspinwinurl: {
			type: String,
			required: true
		},
		verifyurl: {
			type: String,
			required: true
		},
		agreementurl: {
			type: String,
			required: true
		},
		currency: {
			type: String
		},
		shippings: {
			type: Array|Object,
			default: () => ([])
		},
		payments: {
			type: Array|Object,
			default: () => ([])
		},
		countries: {
			type: Object,
			default: () => ({})
		},
		auth_user: {
			type: Array|Object,
		},
		stripePk: {
			type: String
		},
		paypalClientId: {
			type: String
		},
		upsellProduct: {
			type: Array|Object
		}
	},
	data () {
		return {
			loaded: false,
			disabled: false,
			requires_payment: false,
			orderModel: {
				is_company: 1,
				extra_delivery: false,
				agreement: false,
				newsletter: false,
				country: null,
				region: null,
				delivery_country: null,
				delivery_region: null,
			},
			regions: null,
			delivery_regions: null,

			upsellsContents: {},
			fullPage: true,
			loaderOptions: {
				container: this.fullPage ? null : this.$refs.cartcontainer,
				loader: 'dots',
				canCancel: false,
				color: '#E6007E',
				opacity: 0.5,
				zIndex: 999,
			},
			orderComplete: false,
			orderSuccess: false,
			orderError: null,
			orderWarning: null,
			spinWinChecked: false,
			recaptcha_error: false,
			eecSent: false,

			// Payment keys
			klarnaValidCountries: ['at','be','de','dk','es','fi','gb','ie','it','nl','no','se','fr','cz','gr','pl','pt','ch']
		}
	},
	watch: {
		'orderModel.country' (value) {
			const list = this.countries;
			const availableCountries = Object.keys(list)
				.map(function(key) {
					return list[key];
				});
			const selectedCountry = availableCountries.find(obj => {
				return obj.title === value
			})
			if (selectedCountry) {
				this.regions = selectedCountry.regions
			}
			if (this.regions && !this.regions.length) {
				this.regions = null
				this.orderModel.region = null
			}

			// Set stripe if Klarna was selected and country doesn't support it
			this.$nextTick()
			if (this.$store.state.cart.payment?.const === 'klarna' && !this.orderedPayments.find(p => p.const === 'klarna')) {
				this.getPaymentId = this.orderedPayments.find(p => p.const === 'stripe').id
			}
		},
		'orderModel.delivery_country' (value) {
			const list = this.countries;
			const availableCountries = Object.keys(list)
				.map(function(key) {
					return list[key];
				});
			const selectedCountry = availableCountries.find(obj => {
				return obj.title === value
			})
			if (selectedCountry) {
				this.delivery_regions = selectedCountry.regions
			}
			if (this.delivery_regions && !this.delivery_regions.length) {
				this.delivery_regions = null
				this.orderModel.delivery_region = null
			}
		},
		getPaymentId (value) {
			try {
				const coupon_code = this.cartState.coupon && this.cartState.coupon.code ? this.cartState.coupon.code : ''
				const allItems = []
				this.cartState.items.forEach(item => {
					const category = item.eec_parent_category ? item.eec_parent_category : item.category
					const subcategory = !item.eec_parent_category ? '' : item.category
					allItems.push({
						'item_id': item.product_id,
						'item_name': item.title,
						'item_variant': undefined,
						'item_brand': 'Lupit Pole',
						'item_category': category ? category : undefined,
						'item_category2': subcategory ? subcategory : undefined,
						'price': item.price,
						'discount': item.eec_discount,
						'affiliation': item.eec_affiliate ? item.eec_affiliate : undefined,
						'quantity': item.amount,
					})
				})
				let payment_type = ''
				if (this.getPaymentConst === 'paypal') {
					payment_type = 'Paypal'
				} else if (this.getPaymentConst === 'stripe') {
					payment_type = 'Credit card'
				} else if (this.getPaymentConst === 'klarna') {
					payment_type = 'Klarna'
				}

				if (allItems.length === 0) {
					return
				}

				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({'event_params': null, 'ecommerce': null});
				window.dataLayer.push({
					'event': 'RO_event_EEC',
					'event_params': {
						'gtm_name': 'EEC_add_payment_info'
					},
					'ecommerce': {
						'currency': global.current_currency,
						'value': this.cartState.total,
						'coupon': coupon_code ? coupon_code : undefined,
						'payment_type': payment_type,
						'items': allItems
					}
				});
			} catch(e) {}
		},
	},
	computed: {
		orderedPayments: function () {
			return Object.values(_.orderBy(this.payments, 'ord')).filter(p => {
				if (p.const === 'klarna') {
					return this.klarnaValidCountries.includes(this.getCountryCode)
				}
				return true
			})
		},
		orderedShippings: function () {
			return _.orderBy(this.shippings, 'ord')
		},
		isSpinWinCoupon: {
			get () {
				return this.$store.state.cart.is_spin_win_coupon;
			},
			set (value) {
				this.$store.dispatch('cart/setIsSpinWinCoupon', {
					is_spin_win_coupon: value}
				);
			}
		},
		cartState () {
			return this.$store.state.cart
		},
		getPaymentId: {
			get () {
				let payment_id = this.$store.state.cart.payment ? this.$store.state.cart.payment.id : null;
				this.requires_payment = (payment_id && this.payments[payment_id] && this.payments[payment_id].requires_payment);
				return payment_id;
			},
			set (value) {
				this.$store.dispatch('cart/setPayment', {
					payment: value,
				}).then(response => {
					this.calculateShipping()
				});
				this.requires_payment = (value && this.payments[value].requires_payment);
			}
		},
		getPaymentConst () {
			return this.payments[this.getPaymentId]?.const
		},
		getShippingId: {
			get () {
				return this.$store.state.cart.shipping ? this.$store.state.cart.shipping.id : null;
			},
			set (value) {
				this.$store.dispatch('cart/setShipping', {
					shipping: value,
				});
			}
		},
		getShippingCountry: {
			get () {
				return this.$store.state.cart.country ? this.$store.state.cart.country : null;
			},
		},
		getCountryCode () {
			return Object.values(this.countries).find(c => c.title === this.orderModel.country)?.id || null
		},
		cartItems () {
			return this.$store.state.cart.items.map(p => p.product_id)
		},
		upsellProducts () {
			if (this.upsells) {
				return Object.values(this.upsells).filter(p => this.cartItems.indexOf(p.id) <= 0)
			}
			return null;
		},
		surpriseProduct () {
			return this.surprise && this.cartItems.indexOf(this.surprise.id) <= 0 ? this.surprise : false;
		},
		checkoutFormValid () {
			// return getNode('bookingForm').context.state.valid
			return this.$refs.observer ? this.$refs.observer.flags.valid : false;
		},
	},
	methods: {
		async checkSpinWin() {
			const isValid = await this.$refs.observer.validate();
			if (isValid) {
				const coupon_code = this.cartState.coupon && this.cartState.coupon.code ? this.cartState.coupon.code : '';
				if (coupon_code !== '') {
					let loader = this.$loading.show(this.loaderOptions);
					await axios.post(this.checkspinwinurl, {
						coupon_code: coupon_code,
						email: this.orderModel.email
					}).then(async response=> {
						this.spinWinChecked = response.data.isSpinWinValid === 1;

						if (!this.spinWinChecked) {
							this.$swal({
								icon: 'error',
								title: this.$__('checkout.spinwin.coupon_error_title'),
								text:  this.$__('checkout.spinwin.coupon_error_message'),
								confirmButtonColor: '#E6007E'
							});
						}

						loader.hide();
					});
				} else {
					this.spinWinChecked = true;
				}
			}
		},
		calculateShipping() {

			this.$nextTick(() => {
				let loader = this.$loading.show(this.loaderOptions);
				if (this.orderModel.country !== 'choose') {
					document.getElementById('order-country').classList.add('selected');
				} else {
					document.getElementById('order-country').classList.remove('selected');
				}

				const selectRegion = document.getElementById('order-region');
				if (selectRegion) {
					if (this.orderModel.region !== 'choose_region') {
						selectRegion.classList.add('selected');
					} else {
						selectRegion.classList.remove('selected');
					}
				}
				const selectDeliveryCountry = document.getElementById('order-delivery-country');
				if (selectDeliveryCountry) {
					if (this.orderModel.delivery_country !== 'choose') {
						selectDeliveryCountry.classList.add('selected');
					} else {
						selectDeliveryCountry.classList.remove('selected');
					}
				}
				const selectDeliveryRegion = document.getElementById('order-delivery-region');
				if (selectDeliveryRegion) {
					if (this.orderModel.delivery_region !== 'choose_region') {
						selectDeliveryRegion.classList.add('selected');
					} else {
						selectDeliveryRegion.classList.remove('selected');
					}
				}

				const shippingCountry = this.orderModel.delivery_country !== 'choose' ? this.orderModel.delivery_country : this.orderModel.country;
				const shippingRegion = this.orderModel.delivery_region !== 'choose_region' ? this.orderModel.delivery_region : (this.orderModel.region !== 'choose_region' ? this.orderModel.region : null);

				this.$store.dispatch('cart/setShipping', {
					shipping: 1,
					country: shippingCountry,
					region: shippingRegion,
				}).then(response => {
					loader.hide()
				});
			});

		},
		differentAddressShipping() {
			this.orderModel.delivery_country = 'choose'
			this.orderModel.delivery_region = 'choose_region'
			this.calculateShipping()
		},
		checkShipping () {
			this.$store.dispatch('cart/setShipping', {
				shipping: this.orderModel.shipping_id,
				country: this.orderModel.country
			});
		},
		addToCart (product_id) {
			this.$store.dispatch('cart/addToCart', {
				products: [product_id]
			}).then(res => {
			});
			this.$store.dispatch('cart/setShipping', {
				shipping: 1,
				country: this.orderModel.country
			});
		},
		async submitForm () {
			// reCAPTCHA
			await this.$recaptchaLoaded()
			// Execute reCAPTCHA with action "login".
			this.orderModel.token = await this.$recaptcha('login');
			if (['stripe', 'klarna'].includes(this.getPaymentConst)) {
				this.$refs.stripePayment.stripeValidate(this.getCountryCode)
			}

			const isValid = await this.$refs.observer.validate();
			if (!isValid) {
				return false;
			}
			this.pay()
		},
		async orderProcessPaypal (payload) {
			// reCAPTCHA
			await this.$recaptchaLoaded()
			// Execute reCAPTCHA with action "login".
			this.orderModel.token = await this.$recaptcha('login');

			this.orderModel.paypal = payload.paypal
			await this.pay()
		},
		async pay () {
			if (['stripe', 'klarna'].includes(this.getPaymentConst)) {
				if (this.$refs.stripePayment.stripeValidate(this.getCountryCode) === false) {
					return false
				}
			}

			this.disabled = true;
			let loader = this.$loading.show(this.loaderOptions);
			await axios.post(this.payurl, {
				//nonce: nonce,
				data: this.orderModel,
				payment_id: this.getPaymentId,
				shipping_id: this.getShippingId,
			}).then(async response=> {
				if (response.data.payment?.required) {
					switch (response.data.payment.const) {
						case 'stripe':
						case 'klarna': {
							const stripeResponse = await this.$refs.stripePayment.processPayment(response.data.payment.const, response.data.payment.client_secret, {
								...this.orderModel,
								...{
									country: this.getCountryCode,
									orderId: response.data.orderid
								}
							})
							if (stripeResponse.error) {
								console.log('Stripe error', stripeResponse.error)
								this.$refs.stripePayment.setError(stripeResponse.error.message)
								loader.hide()
								break
							}
							if (stripeResponse?.paymentIntent.status === 'succeeded') {
								console.log('Stripe success')
								document.body.classList.add('checkout-complete');
								this.orderComplete = true
								this.orderSuccess = true
								this.orderError = null
								this.orderWarning = null

								if (response.data.warning != 0) {
									this.orderWarning = this.$__('checkout.warning.spinwin')
								}
								// Purchase Event Placeholder
								await this.emitPurchaseEvent(response.data)
								this.$store.dispatch('cart/clearCart')
								this.$store.commit('cart/clearCart')
								loader.hide()
								setTimeout(() => {
									window.scrollTo(0, 0)
								}, 300)
							}
							break
						}
					}
				} else {
					document.body.classList.add('checkout-complete');
					this.orderComplete = true
					if (response.data.error == 0) {
						this.orderSuccess = true
						this.orderError = null
						this.orderWarning = null

						if (response.data.warning != 0) {
							this.orderWarning = this.$__('checkout.warning.spinwin')
						}

						// Purchase Event Placeholder
						await this.emitPurchaseEvent(response.data)
						this.$store.dispatch('cart/clearCart')
						this.$store.commit('cart/clearCart')

					} else {
						this.orderSuccess = false
						//this.$store.commit('cart/clearCart')
						if (response.data.status.message) {
							this.orderError = response.data.status.message
						}
					}
					loader.hide();
					window.scrollTo({ top: 0, left: 0, behavior: 'smooth'});
				}
			}).catch(error => {
				this.orderError = error.response.data.message
				// this.$emit('fail', error.response.data.message)
				// this.loading = false
				loader.hide();
			})
		},
		formatPrice (price) {
			return numbro(parseFloat(price)).formatCurrency();
		},
		async validateForm () {
			// await getNode('bookingForm').submit()
			await this.$refs.observer.validate()
		},
		async emitPurchaseEvent (data) {
			// try {
				// Clear the previous ecommerce object.
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({'event_params': null, 'ecommerce': null});
				dataLayer.push({
					'event': 'purchase',
					'ecommerce': {
						'purchase': {
							'actionField': {
								'id': data.transaction_id,
								'affiliation': 'Online Store',
								'revenue': (Math.round(this.cartState.total * 100) / 100).toFixed(2),
								'tax': 0,
								'shipping': data.shipping_price.toString(),
								'coupon': data.coupon !== null ? data.coupon : ''
							},
							'products':	data.products
						}
					}
				});

				// Send to EEC
				window.dataLayer.push({'event_params': null, 'ecommerce': null});
				window.dataLayer.push({
					'event': 'RO_event_EEC',
					'event_params': {
						'gtm_name': 'EEC_purchase',
						'payment_option': data.payment_option,
						'user_type': data.user_type,
					},
					'ecommerce': {
						'currency': global.current_currency,
						'transaction_id': data.transaction_id,
						'value': data.eec_price,
						'tax': data.eec_tax,
						'shipping': data.shipping_price.toString(),
						'coupon': data.coupon !== null ? data.coupon : undefined,
						'affiliation': data.affiliate ? data.affiliate : undefined,
						'items': Object.values(data.eec_products).map(item => {
							Object.keys(item).forEach(attribute => {
								if (item[attribute] === 'undefined') {
									item[attribute] = undefined
								}
								if (item[attribute] === '') {
									item[attribute] = undefined
								}
							})
							return item
						}),
					}
				});
			// } catch (e) {}
		},
		sendCheckoutEvent () {
			const cartProducts = this.$store.state.cart
			if (cartProducts) {
				const products = cartProducts.items.map(elem => {
					let item = {
						item_id: elem.product_id,
						item_name: elem.title,
						item_variant: undefined,
						item_brand: 'Lupit Pole',
						//item_category: elem.category ? elem.category : undefined,
						price: elem.price,
						discount: elem.eec_discount,
						affiliation: elem.eec_affiliate ? elem.eec_affiliate : undefined,
						quantity: elem.amount,
						coupon: cartProducts.coupon?.rules.coupon_items?.includes(elem.product_id) ? cartProducts.coupon?.code : undefined,
					}

					let categoryCounter = 1
					// [elem?.eec_parent_category, elem?.category].forEach(category => {
					for (const category of [elem?.eec_parent_category, elem?.category].filter(Boolean)) {
						item[`item_category${categoryCounter > 1 ? `_${categoryCounter}` : ``}`] = category
						categoryCounter++
					}

					return item
				});

				try {
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
					window.dataLayer.push({
						event: 'RO_event_EEC',
						event_params: {
							gtm_name: 'EEC_begin_checkout'
						},
						ecommerce: {
							currency: global.current_currency,
							value: cartProducts.total,
							coupon: cartProducts.coupon?.code || undefined,
							items: products
						}
					})
				} catch(e) {}
			}
		}
	},
	mounted() {
		const urlParams = new URLSearchParams(window.location.search);
		if (urlParams.get('order_id') && urlParams.get('redirect_status')) {
			if (urlParams.get('redirect_status') === 'succeeded') {
				document.body.classList.add('checkout-complete');
				this.orderComplete = true
				this.orderSuccess = true
				this.orderError = null
				this.$store.dispatch('cart/clearCart')
				this.$store.commit('cart/clearCart')
				setTimeout(() => {
					window.scrollTo(0, 0)
				}, 300)
			} else {
				document.body.classList.add('checkout-complete');
				this.orderComplete = true
				this.orderSuccess = false
			}
		} else {
			this.$root.$on('recalculate-shipping', () => {
				this.calculateShipping()
			})

			this.$root.$on('reset-spinwin-checked-state', () => {
				this.spinWinChecked = false;
			})

			this.loaded = true;
			this.orderModel.country = 'choose';
			this.orderModel.region = 'choose_region';
			this.orderModel.delivery_country = 'choose';
			this.orderModel.delivery_region = 'choose_region';
			this.$store.dispatch('cart/resetCountry');

			const num_countries = Object.keys(this.countries).length
			if (num_countries === 1) {
				this.orderModel.country = this.countries[Object.keys(this.countries)[0]].title
				this.calculateShipping()
			}

			// check if logged in and populate fields
			if (this.auth_user) {
				this.orderModel = {
					...this.orderModel,
					address:  this.auth_user.address || '',
					town: this.auth_user.city || '',
					name: this.auth_user.name || '',
					surname: this.auth_user.last_name || '',
					email: this.auth_user.email,
					phone: this.auth_user.phone,
					post: this.auth_user.post
				}
				this.calculateShipping()
			}
			// enable to validate on load to display errors
			// this.$refs.observer.validate()
		}
	},
	created() {
		extend('required', {
			...required,
			message: this.$__('checkout.errors.required')
		});
		extend('numeric', {
			...numeric,
			message: this.$__('checkout.errors.numeric')
		});
		extend('email', {
			...email,
			message: this.$__('checkout.errors.email')
		});

		extend('is_not', {
			...is_not,
			message: this.$__('checkout.errors.required')
		});

		extend('notEmptyObject', value => {
			if (Object.keys(value).length) {
				return true;
			}
			return this.$__('general.errors.required');
		});

		this.$store.dispatch('cart/loadCart');

		// Set default payment when only one
		if (Object.keys(this.payments).length === 1) {
			this.$store.dispatch('cart/setPayment', {
				payment: Object.keys(this.payments).pop(),
			});
		}

		// Set to select first payment if none selected
		this.$store.subscribe((mutation, state) => {
			if (mutation.type === 'cart/setCartLoaded') {
				if (!this.getPaymentId) {
					this.$store.dispatch('cart/setPayment', {
						payment: Object.keys(this.payments).pop(),
					});
				}
				if (!this.eecSent) {
					this.$nextTick(() => {
						this.sendCheckoutEvent()
						this.eecSent = true
					});
				}
			}
		});
	}
}
</script>
